import axios from "axios";
const errorsHandler = require("@/services/errors")

//Change This
const module = 'configurations'

const state = {

}

const getters = {

}

const actions = {
    edit : async (context,payload) => {

        let url = `api/v1/${module}/${payload.name}`;

        return await axios.get(`${context.rootGetters['settings/getEndpoint']}${url}`,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return result.data

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
    update : async (context,payload) => {

        let url = `api/v1/${module}/update/${payload.name}`;

        var formData = payload

        return await axios.post(`${context.rootGetters['settings/getEndpoint']}${url}`,formData,{
                'headers': {'Authorization': `Bearer ${context.rootGetters['user/getUser'].token}`},
                "Content-Type": "application/json"
            },
        ).then(result => {

            return {
                success: true,
                result: result.data
            }

        }).catch(error => {
            return errorsHandler.errorHandler(error)
        });

    },
}

const mutations = {

}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

